import React, { Fragment, useState, useContext } from 'react'
import moment from 'moment'
import get from 'lodash/get'
import set from 'lodash/set'

import getQueryName from 'helpers/getNameOfGqlQuery'
import { useMutation } from 'components/graphql'
import { ContentBlock } from 'components/ContentBlock'
import { ExpandableContext } from 'components/ContentBlock/components/ExpandableBlocksContainer'
import { DataTable } from 'components/DataTable'
import { DateIntervalForm } from 'components/shared/DateIntervalForm'
import Button from 'components/Button'
import Divider from 'components/Divider'
import { Modal } from 'components/Modal'
import { Form } from 'components/forms'

import TransactionsModal from '../../modals/TransactionsModal'
import updateCardBalance from '../../gql/updateCardBalance'
import getLoyaltyCard from '../../gql/getLoyaltyCard'
import { loyaltycardTransactions } from '../../tableColumns'
import listLoyaltyCardItems from '../../gql/listLoyaltyCardItems'
import { RefreshSideListContext } from '../../../../components/SectionHandler'


const Transactions = ({ itemId, data, t, ...expandProps }) => {
	const [transactionsPeriod, setPeriod] = useState()
	const { expandedId } = useContext(ExpandableContext)
	const { setRefreshSideList } = useContext(RefreshSideListContext)
	const [showTransaction, setShowTransaction] = useState()
	const [refreshTable, setRefreshTable] = useState(Math.random())

	const [makeTransaction, { loading }] = useMutation(updateCardBalance, {
		onCompleted: () => {
			setShowTransaction(false)
			setRefreshTable(Math.random())
			setRefreshSideList(true)
		}
	})
	const handleTransaction = vals => {
		const dateTime = moment().utcOffset(0, true).toISOString()
		makeTransaction({
			variables: { fields: { cardId: itemId, dateTime, ...vals } },
			update: (cache, { data: mutationData }) => {
				const mutationName = getQueryName(updateCardBalance)
				const queryName = getQueryName(getLoyaltyCard)
				const { balance, points } = mutationData?.[mutationName] || {}
				const cacheParams = { query: getLoyaltyCard, variables: { id: itemId } }
				const cachedQuery = cache.readQuery(cacheParams)
				const newData = { ...cachedQuery }
				set(newData, ['cashAssist', queryName, 'balance'], balance)
				set(newData, ['cashAssist', queryName, 'points'], points)
				cache.writeQuery({
					...cacheParams,
					data: newData
				})
			}
		})
	}

	return(
		<Fragment>
			<ContentBlock label={t('loyalty_card_section.strings.period')} blockId={'2'} {...expandProps}>
				<Form
					initialValues={{ period: { from: moment().utc().startOf('day'), to: moment().utc().endOf('day') } }}
					onSubmit={({ period }) => {
						if (moment.isMoment(period)) {
							setPeriod({ period: { from: moment(period).utc().startOf('day'), to: moment(period).utc().endOf('day') } })
						} else {
							setPeriod({ period })
						}
					}
					}>
					{({ formApi }) => (
						<Fragment>
							<DateIntervalForm formApi={formApi} />
							<Divider />
							<Button type='submit' text={t('common.buttons.calculate')} status='primary' />
						</Fragment>
					)}
				</Form>
			</ContentBlock>

			{(transactionsPeriod && expandedId === '2') &&
				<ContentBlock related alwaysExpanded>
					<DataTable
						key={refreshTable}
						label={t('loyalty_card_section.strings.transactions')}
						columns={loyaltycardTransactions(t)}
						remoteOptions={{
							query: listLoyaltyCardItems,
							variables: { filter: { cardId: itemId, isDeleted: false, ...transactionsPeriod } }
						}}
						withColFilter
						getTrProps={(state, rowInfo) => {
							const { isCancelled } = get(rowInfo, 'original', {})
							return isCancelled ? { className: 'row-warning' } : {}
						}}
						onAddRecord={() => setShowTransaction(true)}
						height={400}
						resizable={false}
					/>
				</ContentBlock>
			}
			{showTransaction &&
				<Modal unmount={() => setShowTransaction(false)} width={660} label={t('loyalty_card_section.strings.loyalty_card_transaction')}>
					<TransactionsModal data={data} onSubmit={handleTransaction} requesting={loading} />
				</Modal>
			}
		</Fragment>
	)
}

export default Transactions
